import { Brackets, Couplings } from 'app/features/configuratorData/slice/types';
import { ItemsPriceType } from 'app/features/price/slice/types';
import { StockStatusType } from 'app/features/stock/slice/types';

export const transformCouplingsAndBracketsDTO: (
  coupling: Couplings,
  bracket: Brackets,
  couplingsAndBracketsPrice: Array<ItemsPriceType>,
  couplingsAndBracketsStockStatus: Array<StockStatusType>,
) => any = (
  coupling: Couplings,
  bracket: Brackets,
  couplingsAndBracketsPrice: Array<ItemsPriceType>,
  couplingsAndBracketsStockStatus: Array<StockStatusType>,
) => {
  let couplingPrice = couplingsAndBracketsPrice?.find(
    item => item.number === coupling.erpPartNumber,
  );
  let bracketPrice = couplingsAndBracketsPrice?.find(
    item => item.number === bracket.erpPartNumber,
  );
  let couplingStock = couplingsAndBracketsStockStatus?.find(
    item => item.number === coupling.erpPartNumber,
  );
  let bracketStock = couplingsAndBracketsStockStatus?.find(
    item => item.number === bracket.erpPartNumber,
  );
  const transformedCouplings: any = {
    ...coupling,
    price: couplingPrice,
    stockStatus: couplingStock,
  };
  const transformedBrackets: any = {
    ...bracket,
    price: bracketPrice,
    stockStatus: bracketStock,
  };
  return {
    coupling: transformedCouplings,
    bracket: transformedBrackets,
  };
};
